package event

import react.FC
import react.ReactNode
import react.Suspense

object EventDo {

    val newYearEvent = FC {
        Suspense{
            this.fallback = ReactNode('s')
            Snow().snowFall()
        }
    }

}